export default function runWalkme($window, rnClient, rnUser) {
  'ngInject';

  return rnClient.getConfig().then(clientConfig => {
    // Only set walkme user information for user entities
    if (_.get(clientConfig, 'entity.type') !== 'User') {
      return;
    }

    return rnUser.getSelectedUserRoles().then(data => {
      let hpUser = data.userRoles.some(userRole => {
        return _.get(userRole, 'systemRole.organizationType') === 'HP';
      });

      _.set($window, 'printos.walkme.hpUser', hpUser);
    });
  });
}
